import React from 'react';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { Link } from 'react-router-dom';

import breakpoints from '../../util/breakpoints';
import { Katy, Nico } from './Person';

const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  margin: 0;
  padding-top: 250px;

  ${breakpoints.sm`
    padding-top: 180px;
  `}

  ${breakpoints.md`
    padding-top: 170px;
  `}
`;

const CenteredCol = styled(Col)`
  text-align: center;
`;

const H2 = styled.h2`
  text-align: center;
`;

const Text = styled.span`
  display: inline;
  font-size: 1em;
  color: white;
  font-weight: 700;
  text-align: center;
  background-color: #1D1F35;
  line-height: 1.4em;

  ${breakpoints.sm`
    font-size: 1.1em;
  `}

  ${breakpoints.lg`
    font-size: 1.2em;
  `}

  ${breakpoints.xl`
    font-size: 1.5em;
  `}
`;

const SubText = styled.span`
  display: block;
  font-size: 0.8em;
  color: white;
  margin: 15px 0;
  background-color: #1D1F35;

  ${breakpoints.sm`
    font-size: 0.9em;
  `}

  ${breakpoints.lg`
    font-size: 1.2em;
    margin: 25px 0;
  `}
`;

const Design = styled.span`
  color: #6483f9;
  font-weight: 700;
`;

const Code = styled.span`
  color: #ff02fd;
  font-weight: 700;
`;

const Button = styled(Link)`
  background-color: #89E7C6;
  color: #1D1F35;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.7em;
  letter-spacing: 0.2em;
  padding: 18px 40px;
  display: inline-block;
  margin-top: 25px;
  cursor: pointer;

  transition: filter 0.5s;

  &:hover {
    filter: brightness(120%);
    color: #1D1F35;
    text-decoration: none;
  }
`;

const HomeHero = () => (
  <Wrapper>

    <Katy />
    <Nico />

    <Container>
      <Row>
        <CenteredCol
          xs={{ size: 10, offset: 1 }}
          sm={{ size: 8, offset: 2 }}
          md={{ size: 6, offset: 3 }}
        >
          <H2><Text><Design>design</Design> &amp; <Code>code</Code><br />for the internet</Text></H2>
          <SubText>
            We help high caliber project teams win.
            <br />
            You share your vision, we make it happen.
            <br />
          </SubText>
          <Button to="/work">see our work</Button>
        </CenteredCol>
      </Row>
    </Container>

  </Wrapper>
);

export default HomeHero;



// WEBPACK FOOTER //
// ./src/components/ui/HomeHero.js